export default __webpack_public_path__ + "static/media/Vendor.d5200428.svg";